/* Scroll reveal.
   Elements carry data-reveal="up" | "img" and an optional data-delay (ms).
   Siblings revealed in the same batch stagger by 90ms. The hidden start state
   lives behind the `.js` class on <html>, so content never disappears if this
   file fails to load. */
(function () {
  var STAGGER = 90;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function show(el, delay) {
    el.style.transitionDelay = delay + 'ms';
    var img = el.dataset.reveal === 'img' ? el.querySelector('img, .reveal-img') : null;
    if (img) img.style.transitionDelay = delay + 'ms';
    el.classList.add('is-revealed');
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { show(el, 0); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    // Count how many siblings reveal together so they can cascade.
    var perParent = new Map();

    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var parent = el.parentElement;
      var n = perParent.get(parent) || 0;
      perParent.set(parent, n + 1);
      show(el, (parseInt(el.dataset.delay, 10) || 0) + n * STAGGER);
      observer.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

  function scan(root) {
    (root || document).querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
      if (el.dataset.revealBound) return;
      el.dataset.revealBound = '1';
      observer.observe(el);
    });
  }

  scan();

  // The theme editor swaps section markup in and out at runtime.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
